import script from "./houseCategory.vue?vue&type=script&setup=true&lang=js"
export * from "./houseCategory.vue?vue&type=script&setup=true&lang=js"

import "./houseCategory.vue?vue&type=style&index=0&id=1baa6a02&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1baa6a02"]])

export default __exports__